(function (Drupal, $, Cookies) {
  // Object to store CSS selectors for different modal elements
  const modalSelectors = {
    defaultPopup: '#block-popup-default .popup',
    blogPopup: '.blog .popup',
    contactModal: '#block-contactmodalblock',
    genericContactModal: '#block-contactmodalblockgeneric',
    webformContactModal: '#block-webformcontactmodalblock',
    webformContactModalAlt: '#block-webformcontactmodalblock--2'
  };
  // Handle clicks on elements that should open the contact modal
  const handleContactModalClick = (e) => {
    // Prevent default action (like following a link)
    e.preventDefault();

    // Determine which contact modal to display based on existence
    const modalId = $(modalSelectors.contactModal).length ? modalSelectors.contactModal :
      $(modalSelectors.genericContactModal).length ? modalSelectors.genericContactModal :
        $(modalSelectors.webformContactModal).length ? modalSelectors.webformContactModal :
          modalSelectors.webformContactModalAlt;

    // Show the determined modal and perform additional actions
    if ($(modalId).length) {
      $(modalId).modal("show");
      adjustFormItems();
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "dsform.popup" });
    }
  };

  // Adjust form items for responsiveness
  const adjustFormItems = () => {
    // Determine if the window width is less than 992px (mobile view)
    const isMobile = $(window).width() < 992;

    // Target different elements based on mobile or desktop view
    const targetSelector = isMobile ? "#edit-industry-interest" : "#edit-phone-comments";

    // Move the first '.form-item-comments' element to the target selector
    $(".form-item-comments").first().appendTo(targetSelector);
  };

  // Setup handler for window resize to adjust form items responsively
  const setupResizeHandler = () => {
    // Adjust form items on window load and resize events
    $(window).on("load resize", adjustFormItems);
  };

  // Attach an event handler to elements with class 'contact-modal-open'
  $(".contact-modal-open").on("click", handleContactModalClick);

  // Setup the resize handler for the window
  setupResizeHandler();

  // Update the data layer for analytics and set a cookie to track modal views
  const updateDataLayerAndCookies = (cookieName) => {
    // Initialize or update the data layer for tracking purposes
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ event: "optimize.activate" });

    // Set a cookie to mark the modal as shown, with a 30-day expiry
    Cookies.set(cookieName, "1", { expires: 30 });
  };

})(Drupal, jQuery, window.Cookies);
